var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageContent',{attrs:{"title":_vm.formTitle}},[_c('div',[_vm._v("个人档案")])])
}
var staticRenderFns = []

export { render, staticRenderFns }